import * as React from 'react'

/**
 * ModalBackgroundのElementが入ったコンテキスト
 */
export const ModalBackgroundContext = React.createContext<HTMLElement | null>(
  null,
)
